// @flow
import React from "react";

type IconProps = {
  fill?: string,
  width?: string,
  className?: string
};

export default function Percent({
  fill = "currentColor",
  width = "12px",
  ...props
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.119 10.243"
      width={width}
      fill={fill}
      fillRule="evenodd"
      {...props}
    >
      <path
        d="M8.561,10.041a2.569,2.569,0,1,1,1,.2A2.552,2.552,0,0,1,8.561,10.041ZM8.468,7.682a1.09,1.09,0,1,0,1.09-1.09A1.091,1.091,0,0,0,8.468,7.682Zm-5.9-.1L8.515,1.625l1.04,1.04L3.6,8.617Zm-1-2.657a2.569,2.569,0,1,1,1,.2A2.552,2.552,0,0,1,1.564,4.92ZM1.47,2.561a1.09,1.09,0,1,0,1.09-1.09A1.091,1.091,0,0,0,1.47,2.561Z"
        transform="translate(0)"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Percent.js